export const fieldGroupOrder = ['most_used', 'other']

export const fieldGroupLabels = {
  most_used: {
    title: 'Most Used Fields',
    description: 'These fields are most commonly used with CleanData, and have been automatically enabled for you.',
    descriptionUpdate: 'These fields are most commonly used with CleanData.',
  },
  other: {
    title: 'Other Fields',
    description: 'These fields are used less often',
  },
}

export const reviewStates = {
  NOT_REVIEWED: 'not_reviewed',
}

export const dupeSetsStates = {
  CREATED: 'created',
  FINISHED: 'write_finished',
  FAILED: 'write_failed',
  QUEUED: 'write_queued',
  MODIFIED: 'modified',
  VIEWED: 'viewed',
  HIGH_MCS_FINISHED: 'high_mcs_write_finished',
  HIGH_MCS_FAILED: 'high_mcs_write_failed',
  HIGH_MCS_QUEUED: 'high_mcs_write_queued',
  NOTIFIED: 'notified_other',
  WRITE_UNDO_QUEUED: 'write_undo_queued',
  WRITE_UNDO_FINISHED: 'write_undo_finished',
  WRITE_UNDO_FAILED: 'write_undo_failed',
  ARCHIVED: 'archived',
}

// rule and object bars: distinct hues, and no red so none reads as an error
export const chartColors = [
  '#2a78d6', // blue
  '#1baf7a', // aqua
  '#eda100', // yellow
  '#7d4007', // dark brown
  '#008300', // green
  '#4a3aa7', // violet
]

export const colorByIssue = {
  damaged: '#9C27B0', //purple
  format: '#795548', // brown
  invalid: '#FF9800', // orange
  junk: '#4CAF50', // green
  misplaced: '#0277BD', // blue
  missing: '#C62828', // red
  contains: '#000000',
  notcontains: '#000000',
}

export const colorByScore = {
  high: 'ap-green',
  medium: 'ap-yellow',
  low: 'ap-orange',
}

// SFDC statusCode -> friendly, customer-facing copy (ENG-12063 phase 2).
// The FE owns this map so copy changes ship centrally and retroactively without
// a backend deploy. Value is a string OR a function of the error dict — the
// function form supports field interpolation / future cases. When a code has no
// entry, the raw SFDC `message` is shown.
export const ERROR_MESSAGE_OVERRIDES = {
  // ENTITY_IS_DELETED is two distinct failures sharing one SFDC statusCode, told
  // apart by `fields` (ENG-12063 vs ENG-12176). Both stay non-reprocessable (see
  // NON_REPROCESSABLE_STATUS_CODES); only the copy differs.
  //   - fields empty  -> a record in the set was deleted by another process
  //                      (ENG-12063): the set is gone, nothing to do.
  //   - fields present -> the merge references a record that was deleted in SFDC
  //                      (ENG-12176): a stale lookup. Recovers on the next scan,
  //                      so we name the field instead of saying records are gone.
  ENTITY_IS_DELETED: e =>
    e.fields?.length
      ? `This set references a record that was deleted in Salesforce ` +
        `(${e.fields.join(', ')}), so the merge could not complete. ` +
        `It will be re-evaluated on the next scan.`
      : 'Some records in this set were already deleted by another person or process.',
  // e.g. later: DUPLICATE_VALUE: e => `Duplicate value on: ${e.fields.join(', ')}`,
}

// SFDC statusCodes whose merge errors must NOT offer Reprocess (ENG-12063).
// e.g. ENTITY_IS_DELETED — a record in the set was already deleted elsewhere,
// so re-running the merge can never succeed.
export const NON_REPROCESSABLE_STATUS_CODES = ['ENTITY_IS_DELETED']

export const defaultDuplicateSetGrouping = 'combine'

export const duplicateSetGroupingOptions = [
  {
    label: 'Combine all duplicates into one set',
    value: 'combine',
  },
  {
    label: 'Create separate duplicate set for each confidence level',
    value: 'separate',
  },
]

// Business Rule names are capped at 109 characters by the backend
export const MAX_RULE_NAME_LENGTH = 109
